if (!customElements.get('variant-metafield-handler')) {
  // Update the styles to better target the size display
  const style = document.createElement('style');
  style.textContent = `
/* Hide size value but keep the "Select Size:" text */
.options-selection__option-name span,
[data-variant-option-choose-name] span {
display: none !important;
}
/* Fix double colon issue */
.options-selection__option-name:: after,
[data-variant-option-choose-name]::after {
display: none !important;
content: "" !important;
}
/* Metafields spacing */
.product-metafields-wrapper {
margin: 16px 0;
}
.product-metafield {
margin-bottom: 16px;
}
.product-metafield:last-child {
margin-bottom: 0;
}
.product-metafield__content {
display: flex;
align-items: center;
gap: 5px;
}
/* Additional cleanup for option selection */
.options-selection__option-name::before {
display: none !important;
}
/* Set font style and weight for the "Select Size:" text */
.options-selection__option-name {
font-style: normal;
font-weight: 700 !important;
}
    
  `;
  document.head.appendChild(style);

  class VariantMetafieldHandler extends HTMLElement {
    constructor() {
      super();
      this.variantData = null;
      this.initialized = false;
      this.currentVariantId = null;
      this.init();
    }

    init() {
      this.loadVariantData();
      
      if (this.variantData) {
        this.createMetafieldElements();
        this.setupEventListeners();
        this.initialized = true;
        
        // Handle initial variant
        this.handleInitialVariant();
      }
    }

    loadVariantData() {
      try {
        const dataElement = document.querySelector('[data-variant-metafields]');
        if (dataElement) {
          this.variantData = JSON.parse(dataElement.textContent.trim());
        }
      } catch (error) {
        console.warn('Error loading variant data:', error);
      }
    }

    createMetafieldElements() {
      this.wrapper = document.createElement('div');
      this.wrapper.className = 'product-metafields-wrapper';

      const fields = [
        { key: 'shape', label: 'Shape', dataKey: 'rug_shape' },
        { key: 'shipping', label: 'Shipping', dataKey: 'shipping' }
      ];

      fields.forEach(field => {
        const div = document.createElement('div');
        div.className = `product-metafield product-metafield--${field.key}`;
        div.setAttribute(`data-variant-${field.key}`, '');
        div.style.display = 'none';
        
        div.innerHTML = `
          <div class="product-metafield__content">
            <span class="product-metafield__label">${field.label}:</span>
            <span class="product-metafield__value"></span>
          </div>
        `;
        
        this.wrapper.appendChild(div);
      });

      this.appendChild(this.wrapper);

      this.elements = {
        title: document.querySelector('.product-title'),
        shape: this.querySelector('[data-variant-shape]'),
        shipping: this.querySelector('[data-variant-shipping]'),
        optionsSelection: document.querySelector('options-selection'),
        variantSelection: document.querySelector('variant-selection')
      };
    }

    handleInitialVariant() {
      // Get initial variant from URL or selected variant
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      
      if (variantId && this.variantData[variantId]) {
        this.updateMetafields(variantId);
      }
    }

    setupEventListeners() {
      // Listen for Empire theme's variant change events
      document.addEventListener('variant-change', (event) => {
        if (event?.detail?.variant?.id) {
          this.updateMetafields(event.detail.variant.id.toString());
        }
      });

      // Listen for Empire's option changes
      if (this.elements.optionsSelection) {
        this.elements.optionsSelection.addEventListener('change', (event) => {
          const variantId = this.elements.variantSelection?.variant;
          if (variantId) {
            this.updateMetafields(variantId);
          }
        });
      }

      // Backup listener for radio button changes
      document.addEventListener('change', (event) => {
        if (event.target.matches('.variant-selection__radio')) {
          const variantId = event.target.value;
          if (variantId) {
            this.updateMetafields(variantId);
          }
        }
      });
    }

    updateMetafields(variantId) {
      if (this.currentVariantId === variantId) return;
      
      const variantMetafields = this.variantData[variantId];
      if (!variantMetafields) return;

      this.currentVariantId = variantId;

      // Update title
      if (this.elements.title && variantMetafields.mfg_title) {
        requestAnimationFrame(() => {
          this.elements.title.textContent = variantMetafields.mfg_title;
        });
      }

      // Update shape
      if (this.elements.shape) {
        const shapeValue = variantMetafields.rug_shape || '';
        const valueElement = this.elements.shape.querySelector('.product-metafield__value');
        if (valueElement) {
          valueElement.textContent = shapeValue;
          this.elements.shape.style.display = shapeValue ? 'block' : 'none';
        }
      }

      // Update shipping
      if (this.elements.shipping) {
        const shippingValue = variantMetafields.shipping || '';
        const valueElement = this.elements.shipping.querySelector('.product-metafield__value');
        if (valueElement) {
          valueElement.textContent = shippingValue;
          this.elements.shipping.style.display = shippingValue ? 'block' : 'none';
        }
      }
    }
  }

  customElements.define('variant-metafield-handler', VariantMetafieldHandler);
}